export default "__VITE_ASSET__BO7Se4h1__"